import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Layout from './components/Layout';
import CookieConsent from './components/CookieConsent';
import HomePage from './pages/HomePage';
import ContattiPage from './pages/ContattiPage';
import ProgettiPage from './pages/ProgettiPage';
import GlossarioPage from './pages/GlossarioPage';
import BiografiePage from './pages/BiografiePage';
import AltriFormatPage from './pages/AltriFormatPage';
import SpotifyPage from './pages/SpotifyPage';
import BigCartelShopPage from './pages/BigCartelShopPage';
// Pagina merchandising nascosta (sarà ripristinata in futuro):
// import ShopPage from './pages/ShopPage';
import GalleryPage from './pages/GalleryPage';
import PrivacyPage from './pages/PrivacyPage';
import FreestylerPage from './pages/FreestylerPage';
import AdminPage from './pages/AdminPage';
import RegolamentoPage from './pages/RegolamentoPage';
import TPStaffPage from './pages/TPStaffPage';
import CypherItaliaPage from './pages/CypherItaliaPage';
import SponsorClientiPage from './pages/SponsorClientiPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contatti" element={<ContattiPage />} />
            <Route path="/progetti" element={<ProgettiPage />} />
            <Route path="/regolamento" element={<RegolamentoPage />} />
            <Route path="/glossario" element={<GlossarioPage />} />
            <Route path="/biografie" element={<BiografiePage />} />
            <Route path="/altri-format" element={<AltriFormatPage />} />
            <Route path="/spotify" element={<SpotifyPage />} />
            <Route path="/shop" element={<BigCartelShopPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/freestyler" element={<FreestylerPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/tp-staff" element={<TPStaffPage />} />
            <Route path="/cypher-italia" element={<CypherItaliaPage />} />
            <Route path="/sponsor-clienti" element={<SponsorClientiPage />} />
          </Routes>
        </Layout>
        <CookieConsent />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
